"use client";

import { useActionState } from "react";

import {
  requestPasswordReset,
  type ForgotPasswordState,
} from "@/app/forgot-password/actions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const initialState: ForgotPasswordState = { status: "idle" };

export function ForgotPasswordForm() {
  const [state, action, pending] = useActionState(requestPasswordReset, initialState);
  return (
    <form action={action} className="mt-7 grid gap-4">
      <label className="grid gap-1.5 text-sm font-medium">
        Email
        <Input autoComplete="email" name="email" required type="email" />
      </label>
      {state.message ? (
        <p
          className={state.status === "error" ? "text-sm text-[var(--color-danger)]" : "text-sm text-[var(--color-success)]"}
          role="status"
        >
          {state.message}
        </p>
      ) : null}
      <Button disabled={pending} type="submit">
        {pending ? "Sending..." : "Send recovery link"}
      </Button>
    </form>
  );
}
